import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { SprakType } from '@src/types/minhelseentities';

import { TagComponent } from './tag-component';

interface Props {
  sprakType: SprakType;
}

const SprakTag = ({ sprakType }: Props): React.JSX.Element | null => {
  const resources = useGetResources();
  if (sprakType === SprakType.NorskBokmal) {
    return <TagComponent tagValue={resources?.sprakNorskBokmal} />;
  }
  if (sprakType === SprakType.NorskNynorsk) {
    return <TagComponent tagValue={resources?.sprakNorskNynorsk} />;
  }
  if (sprakType === SprakType.Engelsk) {
    return <TagComponent tagValue={resources?.sprakEngelsk} />;
  }
  return null;
};

export default SprakTag;
